import { createContext } from 'react';
import { IExtendedRestaurantNfcCards, IUpdateRestaurantNfcCards, NfcCardPermission } from 'types';

export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';

export interface INfcCardsState {
	needRefetchData: boolean;
	initialNfcCards: IExtendedRestaurantNfcCards[];
	nfcCards: IExtendedRestaurantNfcCards[];
	dataForSubmit: Nullable<IUpdateRestaurantNfcCards>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const nfcCardsInitialState: INfcCardsState = {
	needRefetchData: false,
	initialNfcCards: [],
	nfcCards: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface INfcCardsContext extends INfcCardsState {
	refetchData(value: boolean): void;
	addNfcCardsBlock(value: IExtendedRestaurantNfcCards): void;
	deleteNfcCardsBlock(value: string): void;
	changeUUIDCard(settingsId: string, value: string): void;
	changeFullName(settingsId: string, value: string): void;
	changeNfcCardPermission(settingsId: string, value: NfcCardPermission[]): void;
	setDataForSubmit(value: Nullable<IUpdateRestaurantNfcCards>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const NfcCardsContext = createContext<INfcCardsContext>({
	refetchData: () => undefined,
	addNfcCardsBlock: () => undefined,
	deleteNfcCardsBlock: () => undefined,
	changeUUIDCard: () => undefined,
	changeFullName: () => undefined,
	changeNfcCardPermission: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...nfcCardsInitialState,
});
